// Modules
import React from 'react';

// Components
import Header from "./Header";
import Footer from "./Footer";
import SupportSection from "./SupportSection";


const ContactUsUI = () => {
    return (
        <main className="main">
            <Header/>

            <div className={'pagePad__x padTop--l5 padBottom--l8'}>
                <h1 id='faq' className="sectionHeading text__align--center">Contact us</h1>

                <div className="marginTop--l8">
                    <SupportSection/>
                </div>
            </div>

            <Footer/>
        </main>
    );
};

export default ContactUsUI;
